package br.com.vvrefeicoes.portal.core.ui.layout

import androidx.compose.foundation.ScrollState
import androidx.compose.foundation.ScrollbarStyle
import androidx.compose.foundation.VerticalScrollbar
import androidx.compose.foundation.rememberScrollbarAdapter
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import br.com.vvrefeicoes.portal.core.ui.theme.AppShapes

@Composable
actual fun AppScrollbar(
    state: ScrollState,
    modifier: Modifier,
) {
    if (state.maxValue > 0) {
        VerticalScrollbar(
            adapter = rememberScrollbarAdapter(state),
            modifier = modifier,
            style = appScrollbarStyle(),
        )
    }
}

@Composable
internal fun appScrollbarStyle(): ScrollbarStyle {
    val thumbColor = MaterialTheme.colorScheme.onSurfaceVariant.copy(alpha = 0.5f)
    return ScrollbarStyle(
        minimalHeight = 24.dp,
        thickness = 8.dp,
        shape = AppShapes.small,
        hoverDurationMillis = 0,
        unhoverColor = thumbColor,
        hoverColor = thumbColor,
    )
}
